module.exports = __webpack_public_path__ + "static/media/about-section__image.3e66c326.jpg";